import React from 'react';
import PropTypes from 'prop-types';
import Tmnt from '../../Tmnt/Tmnt';

export default function EmptyBag({
  tmntData,
}) {
  return (
    <div className="empty-bag">
      <div className="empty-bag-content">
        <h2 className="empty-bag-title"><Tmnt tmnt={tmntData?.yourBagIsEmptyTMNTValue} /></h2>
        <p className="empty-bag-message"><Tmnt tmnt={tmntData?.addSomethingToYourBagTMNTValue} /></p>
      </div>
    </div>
  );
}

EmptyBag.defaultProps = {
  tmntData: {},
};

EmptyBag.propTypes = {
  tmntData: PropTypes.instanceOf(Object),
};
